//import required libraries
import React, { useContext, useEffect, useState } from "react";

//import library components
import { makeStyles } from "@material-ui/core";
import { Box } from "@material-ui/core";

//import custom components
import SigviewSearchField from "../Common/SigviewSearchField";
import SigviewButton from "../Common/SigviewButton";

// Import contexts
import { ThemeContext } from "../../contexts/ThemeContext";
import SigviewTypography from "../Common/SigviewTypography";

//making styles for all variations
const makeSigviewStyles = (...args) => {
  const [themeColors, customStyle] = args;
  const useStyles = makeStyles(() => ({
    root: {
      display: "flex",
      justifyContent: "space-between",
      padding: customStyle.padding,
      // height: "30px",
      boxSizing: "content-box !important",
      backgroundColor: themeColors["headerBgColor"],
    },
  }));
  return useStyles;
};

function AppMenuBar(props) {
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];
  const {
    onSearchFieldChange = () => {},
    buttonProps = {},
    titleProps = {},
    placeholder = "Search",
    style = {},
  } = props;
  const {
    handleClick: handleButtonClick = () => {},
    title: buttonTitle = "Click Me",
    flag: buttonFlag = true,
  } = buttonProps;
  const {
    title: titleText = "Title",
    flag: titleFlag = false,
  } = titleProps;
  const {
    padding = "10px 25px",
    wrapperBgColor = "#f8f9fd",
    wrapperBorderColor = "1px solid #fff",
    wrapperBorderHover = "#fff",
    wrapperBorderFocus = "#fff",
  } = style;

  // * Define required states
  const [searchField, setSearchField] = useState("");

  // * Define required event handlers
  const handleSearchFieldChange = (event, value) => setSearchField(value);

  // * Define required side effects
  useEffect(() => {
    onSearchFieldChange(null, searchField);
  }, [searchField]);

  // * Define required static variables
  const createChartStyle = { buttonHeight: "2.25em", borderRadius: "999em" };
  const customStyle = { padding };
  const useSigviewStyles = makeSigviewStyles(themeColors, customStyle);
  const classes = useSigviewStyles();
  var btnText = buttonTitle.replace(/ +/g, "");

  return (
    <section className={classes.root}>
      {titleFlag && (
        <Box style={{ marginRight: "10px", flex: "1 1 0" }}>
          <SigviewTypography
            style={{
              fontSize: "18px",
              lineHeight: "2",
              color: "#46596a",
            }}
            variant="heading"
          >
            {titleText}
          </SigviewTypography>
        </Box>
      )}
      <Box
        css={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          gap: "10px",
          flex: "1 1 0",
        }}
      >
        {buttonFlag && (
          <SigviewButton
            variant="containedPrimary"
            onClick={handleButtonClick}
            title={buttonTitle}
            iconFlag={true}
            customClassName={`${btnText}-GA`}
            iconProps={{
              className: "material-icons-round",
              iconName: "add_circle",
            }}
            iconStyle={{fontSize: "14px"}}
            style={createChartStyle}
          />
        )}
        <Box
          css={{
            width: "100%",
            maxWidth: "270px",
            minWidth: "200px",
            position: "relative",
            top: "0px",
          }}
        >
          <SigviewSearchField
            placeholder={placeholder}
            onChange={handleSearchFieldChange}
            customClassName={`${
              buttonTitle === "Create Chart"
                ? "SearchInSavedChart-GA"
                  ? buttonTitle === "Create New Group"
                  : "CreateNewGroup-GA"
                  ? buttonTitle === "Create New User"
                  : "CreateNewUser-GA"
                : "SearchInSavedDatastory-GA"
            }`}
            customStyle={{
              wrapperBgColor: wrapperBgColor,
              wrapperBorderHover: wrapperBorderHover,
              wrapperBorderFocus: wrapperBorderFocus,
              wrapperBorderColor: wrapperBorderColor,
            }}
          />
        </Box>
      </Box>
    </section>
  );
}

export default AppMenuBar;
